import { createReducer } from "@reduxjs/toolkit";
import { signIn, signInSuccess, signInFailure, signInReset } from "./actions";
import {
  signInGoogle,
  signInMetamask,
  signInTwitch,
  signInTwitter,
  toggleSignInModalType,
} from "./actionTypes";

const initialState = {
  signedWith: null,
  none: null,
  isLoading: false,
  isSuccess: false,
  error: null,
  isModalVisible: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(signIn.type, (state) => ({
      ...state,
      error: null,
      isLoading: true,
    }))
    .addCase(signInMetamask.request, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(signInGoogle.request, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(signInTwitch.request, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(signInTwitter.request, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(signInSuccess.type, (state, action) => ({
      ...state,
      signedWith: action.payload.signInWith,
      isLoading: false,
      isSuccess: true,
      isModalVisible: false,
    }))
    .addCase(signInFailure.type, (state, action) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(signInReset.type, (_state, action) => ({
      ...initialState,
      ...(action.payload ? action.payload : {}),
    }))
    .addCase(toggleSignInModalType, (state, action) => {
      return {
        ...state,
        isModalVisible: action.payload,
      };
    });
});
